export enum FeaturePhotoValueType {
  ARRAY_OBJECT = "array-object",
  ARRAY_VALUE = "array-value",
  SINGLE = "single"
}

export interface FeaturePhotoItem {
  id?: number;
  md_id?: string;
  src?: string;
  thumbnail?: string;
  original?: string;
  originalUrl?: string;
  thumbnailUrl?: string;
  alt?: string;
}

export interface ParsedFeaturePhotoValue {
  type: FeaturePhotoValueType;
  items: FeaturePhotoItem[];
}
